<template>
  <v-container class="fill-height">
    <v-row class="text-center" justify="center" align="center">
      <v-col class="mb-4" cols="12">
        <div class="display-1 mb-3">
          {{ $t('thankyou.title')}}
        </div>
        <div v-html="$t('thankyou.description_onlinepayment')" v-if="paymentMethod === 'online'" />
        <div v-html="$t('thankyou.description')" v-else/>

      </v-col>
      <v-col class="mb-4" cols="12" v-if="paymentMethod === 'online'">
        <div  v-if="loadingPayment">
          <div>Lade Bezahlstatus</div>
          <v-progress-circular indeterminate>
          </v-progress-circular>
        </div>
        <div v-else>
          <v-card rounded>
            <v-card-title style="justify-content: center">Bezahlstatus</v-card-title>
            <v-card-text>
              <div>Bestellnummer: <strong>{{ paymentData.order_no}}</strong></div>
              <div>Status: <strong>{{ $t(`checkout.${paymentData.payment_status}`) }}</strong></div>
              <div>Betrag: <strong>{{ paymentData.amount_total/100 | currency }} inkl. MwSt.</strong></div>
            </v-card-text>
            <v-card-text>{{ paymentData.customer_details.name}} ({{ paymentData.customer_details.email}})</v-card-text>
            <v-card-text></v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col class="mb-4" cols="12">
        <div class="headline mb-3">
          {{ $t('thankyou.title2')}}
        </div>
        <div>
          <v-btn rounded class="buttonColor--text secondary ma-2" large @click="share('whatsapp')">
            <v-icon left>mdi-whatsapp</v-icon>
            Whatsapp
          </v-btn>

          <v-btn rounded class="buttonColor--text secondary ma-2" large @click="share('facebook')">
            <v-icon left>mdi-facebook</v-icon>
            Facebook
          </v-btn>

          <v-btn rounded class="buttonColor--text secondary ma-2" large @click="share('email')">
            <v-icon left>mdi-email</v-icon>
            Email
          </v-btn>

          <v-btn rounded class="buttonColor--text secondary ma-2" large @click="share('sms')">
            <v-icon left>mdi-message</v-icon>
            SMS
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row class="text-center" justify="center" align="center">
      <v-col class="mb-4" cols="12">
        <v-btn rounded class="buttonColor--text secondary ma-2" large @click="$router.push('/')">{{ $t('thankyou.finished') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

const fb = require('@/firebase/config.js');

export default {
  name: 'Thankyou',
  components: {},
  computed: {
  },
  data: () => ({
    shareTitle: 'Hol dir deinen Sônggl 2021',
    shareDescription: 'Hol dir deinen Sônggl 2021',
    shareUrl: 'https://kilbi-songgl.lustenau.at',
    loadingPayment: false,
    paymentMethod: null,
    paymentData: null
  }),
  mounted() {
    // this.$analytics.logEvent("page_view");
    // this.$analytics.logEvent("screen_view", {
    //  screen_name: 'thankyou',
    //});
    this.getOrderData()
  },
  methods: {
    async getOrderData() {
      console.log(this.$route.query)
      if (this.$route.query['session_id']) {
        this.paymentMethod = 'online'
        console.log('session id = ', this.$route.query['session_id'])

        const self = this
        this.loadingPayment = true
        const data = { sessionId:  this.$route.query['session_id']}
        const stripeCreatePaymentSession = fb.fire.app().functions('europe-west1').httpsCallable('stripeGetSession')
        await stripeCreatePaymentSession(data)
            .then((result) => {
              console.log('result from Stripe create payment', result)
              self.paymentData = result.data.data
            })
            .catch((error) => {
              console.log('error', error)
            })
            .finally(() => {
              self.loadingPayment = false
            })

      }
    },
    addWorkdays (days) {
      let currentDate = new Date();

      for (let i =1; i <= days; i++)
      {
        currentDate.setDate(currentDate.getDate() + 1 );
        if (currentDate.getDay() == 6)
        {
          currentDate.setDate(currentDate.getDate() + 2 );
        }
        else if (currentDate.getDay() == 0)
        {
          currentDate.setDate(currentDate.getDate() + 1 );
        }
      }
      return currentDate.toLocaleString('de-de',{month:'long', year:'numeric', day:'numeric'})
      //return currentDate.getDate() + '.' + (currentDate.getMonth() + 1 ) + '.'
    },
    share(network) {
      var link = "";

      switch (network) {
        case 'whatsapp':
          link = 'https://api.whatsapp.com/send?text=@t%0D%0A@u%0D%0A';
          break;
        case 'facebook':
          link = 'https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d';
          break;
        case 'email':
          link = 'mailto:?body=@d%20@u&subject=@t';
          break;
        case 'sms':
          link = 'sms:?body=@t%0D%0A@u';
          break;
      }

      link = this.getLink(link);

      window.open(link, '_blank');
    },
    getLink(link) {
      const self = this
      return link
          .replace(/@u/g, encodeURIComponent(self.$t('share.url')))
          .replace(/@t/g, encodeURIComponent(self.$t('share.title')))
          .replace(/@d/g, encodeURIComponent(self.$t('share.description')))
    }
  }
}
</script>
